<template>
  <span class="assetLibrary">
    <div class="assetList">
      <template v-for="assetType in assets">
        <el-card
          v-for="asset of assetType.data"
          :key="asset.id"
          draggable="true"
          v-on:dragstart="handleDrag({ type: 'image', asset: asset })"
          class="asset-card"
        >
          <div @click="selectAsset(asset)" class="assetItem">
            <span
              :key="asset.id"
              :transfer-data="{ type: 'image', asset: asset }"
            >
              <div v-if="asset.asset_type == 'image'" class="image-container">
                <img :src="asset.url" class="asset-image" />
              </div>
              <div v-if="asset.asset_type == 'audio'" preload="none">
                <audio controls>
                  <source :src="asset.url" :type="asset.mime_type" />
                </audio>
              </div>
              <div class="asset-name">{{ asset.name }} {{ asset.id }}</div>
            </span>
          </div>
        </el-card>
      </template>
    </div>
    <p v-if="assets.length === 0">
      looks like you don't have any assets yet. drag &amp; drop them here or
      press the button below. then, drag them onto the pages to the right and
      begin creating your masterpiece!
    </p>
    <div style="margin-top: 10px">
      Add new:
      <asset-inline-upload
        :asset-types="assetTypes"
        @upload-complete="handleAssetAdd"
        @upload-error="handleUploadError"
      ></asset-inline-upload>
    </div>
  </span>
</template>

<script>
import assetService from '../../services/assetsServices';
import AssetInlineUpload from 'src/components/UIComponents/AssetInlineUpload.vue';

export default {
  components: {
    AssetInlineUpload,
  },
  data() {
    return {
      assets: [],
      selectedAsset: undefined,
      beforeId: undefined,
    };
  },
  emits: ['update:modelValue', 'close'],
  props: {
    assetTypes: {
      type: Array,
      default: () => ['image', 'pdf'],
      validator: (value) => {
        const validTypes = [
          'image',
          'video',
          'audio',
          'pdf',
          'text',
          'binary',
          'html',
        ];
        return value.every((type) => validTypes.includes(type));
      },
    },
    value: Object, // Starting value from Vue model
    limit: { type: Number, default: 20 },
    thumbnailMode: { type: Boolean, default: false },
  },
  created() {
    this.fetchAssets();
  },
  mounted() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.$emit('close');
      }
    });
  },

  methods: {
    fetchAssets() {
      // TODO: We need a valid id to sort on, uuid will not give order.
      // Or we need an index on created_at, most have few assests so we are
      // good for now.
      Promise.all(
        this.assetTypes.map((assetType) =>
          assetService.fetchAssets(
            undefined,
            this.limit,
            undefined,
            'created_at:desc', // Need a before Id for reverse listing
            assetType
          )
        )
      ).then((responses) => {
        // Merge and sort all assets by creation date
        this.assets = responses
          .flatMap((resp) => resp.data)
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        this.afterId = this.assets.length
          ? this.assets[this.assets.length - 1].id
          : this.beforeId;
      });
    },
    handleAssetAdd(asset) {
      this.assets.unshift(asset);
      this.selectAsset(asset);
    },
    handleUploadError(error) {
      // TODO: What should this do?
      console.error("error uploading asset", error);
    },
    closeModal() {
      this.$emit('close');
    },
    selectAsset(a) {
      this.selectedAsset = a;
      this.$emit('update:modelValue', a);
      this.$emit('update', a);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.assetList {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.asset-card {
  width: 200px;
}

.image-container {
  width: 200px;
  height: 200px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.asset-image {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
}

.asset-name {
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assetItem {
  padding: 0.25em;
  cursor: pointer;
}
</style>
